module.exports = __webpack_public_path__ + "static/media/product.1825c79a.png";